export default {
  methods: {
    isAdmin(user) {
      return user.roles.some(role => role === 'ROLE_SUPER_ADMIN')
    },
    setAdmin(user) {
      if (this.isAdmin(user)) {
        user.roles = [
          ...user.roles.slice(0, user.roles.indexOf('ROLE_SUPER_ADMIN')), 
          ...user.roles.slice(user.roles.indexOf('ROLE_SUPER_ADMIN') + 1)
        ]
      } else {
        user.roles = [...user.roles, 'ROLE_SUPER_ADMIN']
      }
    }
  }
}